import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const useStyles = makeStyles({
  root: {
    background: 'white',
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    // padding: '10px',
    overflow: 'hidden',
    // margin: 10
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    minHeight: '100px',
    height: 700,
    marginTop: 30,
    marginBottom: 20,
  },
});

export const FBAHistoryMatchDataTable = ({ fba, darkMode }) => {

  try {
    // STYLES
    const classes = useStyles();

    if (!fba?.historyMatch || fba?.historyMatch?.length === 0) return (<></>);

    const columns = [
      {
        field: 'date',
        headerName: 'Date',
        width: 175,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        type: 'string'
      },
      {
        field: 'days',
        headerName: 'Days',
        width: 75,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        // type: 'number'
      },
      {
        field: 'water',
        headerName: 'Water Rate (stb/d)',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'oil',
        headerName: 'Oil Rate (stb/d)',
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'gas',
        headerName: 'Gas Rate (mscf/d)',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumWater',
        headerName: 'Cum. Water (stb)',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumOil',
        headerName: 'Cum. Oil (stb)',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumGas',
        headerName: 'Cum. Gas (mscf)',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'pwf',
        headerName: 'Pwf (psi)',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'simulatorPbar',
        headerName: 'Simulator Pbar',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'simulatorSw',
        headerName: 'Simulator Sw',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'krw',
        headerName: 'krw',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'kro',
        headerName: 'kro',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'ct',
        headerName: 'ct',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'lambda',
        headerName: 'lambda',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'kfOverKfi',
        headerName: 'kf/kfi',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'phiFOverPhiFi',
        headerName: 'phif/phifi',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'bwOverBwi',
        headerName: 'Bw/Bwi',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'boOverBoi',
        headerName: 'Bo/Boi',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'mwv',
        headerName: 'MWV',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'mwvCt',
        headerName: 'MWVCt',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'tD',
        headerName: 'tD',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qD',
        headerName: 'qD',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'q',
        headerName: 'q',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qTrans',
        headerName: 'qTrans',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qTransOR',
        headerName: 'qTransORPSS',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumTransOR',
        headerName: 'Cum. TransORPSS',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumTransORPostBT',
        headerName: 'Cum. TransORPSS ABT',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'waterPbar',
        headerName: 'Water Pbar',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'timeLinearFlow',
        headerName: 'Time Linear Flow',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'tDxFOilLinear',
        headerName: 'tDxFOilLinear',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qDOilLinear',
        headerName: 'qDOilLinear',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qOilLinear',
        headerName: 'qOilLinear',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumBblOilLinear',
        headerName: 'Cum. Bbl Oil Linear',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'oilPbarLinear',
        headerName: 'Oil Pbar Linear',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'tDxFWaterLinear',
        headerName: 'tDxFWaterLinear',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qDWaterLinear',
        headerName: 'qDWaterLinear',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qWaterLinear',
        headerName: 'qWaterLinear',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumBblWaterLinear',
        headerName: 'Cum. Bbl Water Linear',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumWLinear',
        headerName: 'Cum. W. Linear',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'waterPbarLinear',
        headerName: 'Water Pbar Linear',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qOilFracture',
        headerName: 'qOilFracture',
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumBblOilFracture',
        headerName: 'Cum. Bbl Oil Fracture',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qGasFracture',
        headerName: 'qGasFracture',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumBblGasFracture',
        headerName: 'Cum. Bbl Gas Fracture',
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
    ];

    let rows = [];

    fba?.fbaData?.forEach((value, index) => {
      rows.push({
        id: index,
        date: (new Date(value?.date)?.toLocaleDateString() + ' ' + (new Date(value?.date)?.toLocaleTimeString()) || 0),
        days: (value?.days) || 0,
        water: (value?.water) || 0,
        oil: (value?.oil) || 0,
        gas: (value?.gas) || 0,
        cumWater: (value?.cumWater) || 0,
        cumOil: (value?.cumOil) || 0,
        cumGas: (value?.cumGas) || 0,
        pwf: (value?.pwf) || 0,
        simulatorPbar: (fba?.historyMatch?.[index]?.simulatorPbar) || 0,
        simulatorSw: (fba?.historyMatch?.[index]?.simulatorSw) || 0,
        krw: (fba?.historyMatch?.[index]?.krw) || 0,
        kro: (fba?.historyMatch?.[index]?.kro) || 0,
        ct: (fba?.historyMatch?.[index]?.ct) || 0,
        lambda: (fba?.historyMatch?.[index]?.lambda) || 0,
        kfOverKfi: (fba?.historyMatch?.[index]?.kfOverKfi) || 0,
        phiFOverPhiFi: (fba?.historyMatch?.[index]?.phiFOverPhiFi) || 0,
        bwOverBwi: (fba?.historyMatch?.[index]?.bwOverBwi) || 0,
        boOverBoi: (fba?.historyMatch?.[index]?.boOverBoi) || 0,
        mwv: (fba?.historyMatch?.[index]?.mwv) || 0,
        mwvCt: (fba?.historyMatch?.[index]?.mwvCt) || 0,
        tD: (fba?.historyMatch?.[index]?.tD) || 0,
        qD: (fba?.historyMatch?.[index]?.qD) || 0,
        q: (fba?.historyMatch?.[index]?.q) || 0,
        qTrans: (fba?.historyMatch?.[index]?.qTrans) || 0,
        qTransOR: (fba?.historyMatch?.[index]?.qTransOR) || 0,
        cumTransOR: (fba?.historyMatch?.[index]?.cumTransOR) || 0,
        cumTransORPostBT: (fba?.historyMatch?.[index]?.cumTransORPostBT) || 0,
        waterPbar: (fba?.historyMatch?.[index]?.waterPbar) || 0,
        timeLinearFlow: (fba?.historyMatch?.[index]?.timeLinearFlow) || 0,
        tDxFOilLinear: (fba?.historyMatch?.[index]?.tDxFOilLinear) || 0,
        qDOilLinear: (fba?.historyMatch?.[index]?.qDOilLinear) || 0,
        qOilLinear: (fba?.historyMatch?.[index]?.qOilLinear) || 0,
        cumBblOilLinear: (fba?.historyMatch?.[index]?.cumBblOilLinear) || 0,
        oilPbarLinear: (fba?.historyMatch?.[index]?.oilPbarLinear) || 0,
        tDxFWaterLinear: (fba?.historyMatch?.[index]?.tDxFWaterLinear) || 0,
        qDWaterLinear: (fba?.historyMatch?.[index]?.qDWaterLinear) || 0,
        qWaterLinear: (fba?.historyMatch?.[index]?.qWaterLinear) || 0,
        cumBblWaterLinear: (fba?.historyMatch?.[index]?.cumBblWaterLinear) || 0,
        cumWLinear: (fba?.historyMatch?.[index]?.cumWLinear) || 0,
        waterPbarLinear: (fba?.historyMatch?.[index]?.waterPbarLinear) || 0,
        qOilFracture: (fba?.historyMatch?.[index]?.qOilFracture) || 0,
        cumBblOilFracture: (fba?.historyMatch?.[index]?.cumBblOilFracture) || 0,
        qGasFracture: (fba?.historyMatch?.[index]?.qGasFracture) || 0,
        cumBblGasFracture: (fba?.historyMatch?.[index]?.cumBblGasFracture) || 0,
      });
    });

    return (
      <div className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: GridToolbar,
          }}
          sx={{
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: darkMode ? 'grey' : 'whitesmoke'
            }
          }}
          style={{overflow: 'scroll'}}
        />
      </div>
    );
  } catch (error) {
    return <></>
  };
};
